import {
    handleConsignmentAddNotes,
    handleConsignmentBillingNotes,
    handleEquityNotes,
    handleReportUsageNotes,
    handleSurgeryNotes,
} from 'src/common/redux/actions';
import { convertDateToISOString, isMobileDevice } from 'src/utils/util';

export const handleSave = ({
    from,
    isSurgery,
    isFromConsignmentBilling,
    isFromEquity,
    isFromConsignmentAdd,
    isFromReportUsage,
    isTransferSurgery,
    notesOnetext,
    notesTwoText,
    notesOneDisplay,
    notesTwoDisplay,
    displayName,
    dispatch,
    setNotesOnetext,
    setNotesTwoText,
}) => {
    let newNotes = [];
    if (isSurgery) {
        if (from === 'noteOne') {
            newNotes = [
                {
                    customerNotes: [
                        {
                            creationDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            formattedDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            note: notesOnetext,
                            isTransferSurgery: isTransferSurgery,
                            isReservationSetNote: false,
                            isBusinessNote: false,
                            typeOfNote: 'SalesRepNotes',
                            userName: displayName,
                            statusOfSEOrder: null,
                            isNew: true,
                        },
                        ...notesOneDisplay,
                    ],
                    surgeryNotes: [...notesTwoDisplay],
                },
            ];
            setNotesOnetext('');
        } else if (from === 'noteTwo') {
            newNotes = [
                {
                    customerNotes: [...notesOneDisplay],
                    surgeryNotes: [
                        {
                            creationDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            formattedDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            note: notesTwoText,
                            typeOfNote: 'UserNotes',
                            isTransferSurgery: isTransferSurgery,
                            isReservationSetNote: false,
                            isBusinessNote: false,
                            userName: displayName,
                            statusOfSEOrder: null,
                            isNew: true,
                        },
                        ...notesTwoDisplay,
                    ],
                },
            ];
        }
        dispatch(handleSurgeryNotes(newNotes));
    } else if (isFromConsignmentBilling) {
        if (from === 'noteOne') {
            newNotes = [
                {
                    consignmentBillingNotes: [
                        {
                            creationDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            formattedDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            note: notesOnetext,
                            isReservationSetNote: false,
                            isBusinessNote: false,
                            typeOfNote: 'SalesRepNotes',
                            userName: displayName,
                            statusOfSEOrder: null,
                            isNew: true,
                        },
                        ...notesOneDisplay,
                    ],
                    consignmentReplenishmentNotes: [...notesTwoDisplay],
                },
            ];
        } else if (from === 'noteTwo') {
            newNotes = [
                {
                    consignmentBillingNotes: [...notesOneDisplay],
                    consignmentReplenishmentNotes: [
                        {
                            creationDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            formattedDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            note: notesTwoText,
                            typeOfNote: 'SalesRepNotes',
                            isReservationSetNote: false,
                            isBusinessNote: false,
                            userName: displayName,
                            statusOfSEOrder: null,
                            isNew: true,
                        },
                        ...notesTwoDisplay,
                    ],
                },
            ];
        }
        dispatch(handleConsignmentBillingNotes(newNotes));
    } else if (isFromEquity) {
        if (from === 'noteOne') {
            let existingNote = isMobileDevice()
                ? notesOneDisplay
                : notesTwoDisplay;
            newNotes = [
                {
                    equityNotes: [
                        {
                            creationDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            formattedDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            note: notesOnetext,
                            isReservationSetNote: false,
                            isBusinessNote: false,
                            typeOfNote: 'SalesRepNotes',
                            userName: displayName,
                            statusOfSEOrder: null,
                            isNew: true,
                        },
                        ...existingNote,
                    ],
                },
            ];
        }
        dispatch(handleEquityNotes(newNotes));
    } else if (isFromConsignmentAdd) {
        if (from === 'noteOne') {
            let existingNote = isMobileDevice()
                ? notesOneDisplay
                : notesTwoDisplay;
            newNotes = [
                {
                    consignmentAddNotes: [
                        {
                            creationDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            formattedDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            note: notesOnetext,
                            isReservationSetNote: false,
                            isBusinessNote: false,
                            typeOfNote: 'SalesRepNotes',
                            userName: displayName,
                            statusOfSEOrder: null,
                            isNew: true,
                        },
                        ...existingNote,
                    ],
                },
            ];
        }
        dispatch(handleConsignmentAddNotes(newNotes));
    } else if (isFromReportUsage) {
        if (from === 'noteOne') {
            newNotes = [
                {
                    reportUsageNotes: [
                        {
                            creationDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            formattedDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            note: notesOnetext,
                            isReservationSetNote: false,
                            isBusinessNote: false,
                            typeOfNote: 'SalesRepNotes',
                            isNew: true,
                            userName: displayName,
                            statusOfSEOrder: null,
                        },
                        ...notesOneDisplay,
                    ],
                    reportReplenishmentNotes: [...notesTwoDisplay],
                },
            ];
        } else if (from === 'noteTwo') {
            newNotes = [
                {
                    reportUsageNotes: [...notesOneDisplay],
                    reportReplenishmentNotes: [
                        {
                            creationDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            formattedDate: convertDateToISOString(
                                new Date(),
                                'original'
                            ),
                            note: notesTwoText,
                            isNew: true,
                            typeOfNote: 'SalesRepNotes',
                            isReservationSetNote: false,
                            isBusinessNote: false,
                            userName: displayName,
                            statusOfSEOrder: null,
                        },
                        ...notesTwoDisplay,
                    ],
                },
            ];
        }
        dispatch(handleReportUsageNotes(newNotes));
    }
    
    // Clear text fields after saving
    if (from === 'noteOne') {
        setNotesOnetext('');
    } else {
        setNotesTwoText('');
    }
};

export const handleDelete = ({
    itemIndex,
    type,
    isSurgery,
    isFromConsignmentBilling,
    isFromEquity,
    isFromConsignmentAdd,
    isFromReportUsage,
    notesOneDisplay,
    notesTwoDisplay,
    dispatch,
    setEditNoteOne,
    setEditNoteTwo,
}) => {
    const DataArray = type === 'notes1' ? notesOneDisplay : notesTwoDisplay;
    const filteredNotesDisplay = DataArray.filter(
        (note, index) => index !== itemIndex
    );
    let newNotes = [];
    
    if (type === 'notes1') {
        if (isSurgery) {
            newNotes = [
                {
                    customerNotes: filteredNotesDisplay,
                    surgeryNotes: [...notesTwoDisplay],
                },
            ];
        } else if (isFromConsignmentBilling) {
            newNotes = [
                {
                    consignmentBillingNotes: filteredNotesDisplay,
                    consignmentReplenishmentNotes: [...notesTwoDisplay],
                },
            ];
        } else if (isFromReportUsage) {
            newNotes = [
                {
                    reportUsageNotes: filteredNotesDisplay,
                    reportReplenishmentNotes: [...notesTwoDisplay],
                },
            ];
        } else if (isFromEquity) {
            newNotes = [
                {
                    equityNotes: filteredNotesDisplay,
                },
            ];
        } else if (isFromConsignmentAdd) {
            newNotes = [
                {
                    consignmentAddNotes: filteredNotesDisplay,
                },
            ];
        }
    } else {
        if (isSurgery) {
            newNotes = [
                {
                    customerNotes: [...notesOneDisplay],
                    surgeryNotes: filteredNotesDisplay,
                },
            ];
        } else if (isFromConsignmentBilling) {
            newNotes = [
                {
                    consignmentBillingNotes: [...notesOneDisplay],
                    consignmentReplenishmentNotes: filteredNotesDisplay,
                },
            ];
        } else if (isFromEquity) {
            newNotes = [
                {
                    equityNotes: filteredNotesDisplay,
                },
            ];
        } else if (isFromConsignmentAdd) {
            newNotes = [
                {
                    consignmentAddNotes: filteredNotesDisplay,
                },
            ];
        } else if (isFromReportUsage) {
            newNotes = [
                {
                    reportUsageNotes: [...notesOneDisplay],
                    reportReplenishmentNotes: filteredNotesDisplay,
                },
            ];
        }
    }
    
    // Dispatch appropriate action based on context
    if (isSurgery) {
        dispatch(handleSurgeryNotes(newNotes));
    } else if (isFromConsignmentBilling) {
        dispatch(handleConsignmentBillingNotes(newNotes));
    } else if (isFromEquity) {
        dispatch(handleEquityNotes(newNotes));
    } else if (isFromConsignmentAdd) {
        dispatch(handleConsignmentAddNotes(newNotes));
    } else if (isFromReportUsage) {
        dispatch(handleReportUsageNotes(newNotes));
    }
    
    // Reset edit states
    setEditNoteOne('');
    setEditNoteTwo('');
};

export const handleEditSaveTwo = ({
    index,
    notesTwoDisplay,
    notesOneDisplay,
    editNoteTwoValue,
    isSurgery,
    isFromConsignmentBilling,
    isFromEquity,
    isFromConsignmentAdd,
    isFromReportUsage,
    dispatch,
    setEditNoteTwo,
    setEditNoteTwoValue,
    setNotesCount,
    handleDelete
}) => {
    // Use the edited value if present, otherwise use the current note
    const valueToSave =
        editNoteTwoValue !== null && editNoteTwoValue !== undefined
            ? editNoteTwoValue
            : notesTwoDisplay[index]?.note;

    // If the note is empty, delete it
    if (!valueToSave || valueToSave.trim() === '') {
        handleDelete(null, index, 'notes2');
        setEditNoteTwo(null);
        setEditNoteTwoValue(null);
        setNotesCount(prev => prev - 1);
        return;
    }

    const updatedNotesTwoDisplay = [...notesTwoDisplay];
    updatedNotesTwoDisplay[index] = {
        ...updatedNotesTwoDisplay[index],
        isNew: true,
        note: valueToSave.trim(),
        creationDate: convertDateToISOString(new Date(), 'original'),
    };

    if (isSurgery) {
        const newNotes = [
            {
                customerNotes: [...notesOneDisplay],
                surgeryNotes: updatedNotesTwoDisplay,
            },
        ];
        dispatch(handleSurgeryNotes(newNotes));
    } else if (isFromConsignmentBilling) {
        const newNotes = [
            {
                consignmentBillingNotes: [...notesOneDisplay],
                consignmentReplenishmentNotes: updatedNotesTwoDisplay,
            },
        ];
        dispatch(handleConsignmentBillingNotes(newNotes));
    } else if (isFromEquity) {
        const newNotes = [
            {
                equityNotes: updatedNotesTwoDisplay,
            },
        ];
        dispatch(handleEquityNotes(newNotes));
    } else if (isFromConsignmentAdd) {
        const newNotes = [
            {
                consignmentAddNotes: updatedNotesTwoDisplay,
            },
        ];
        dispatch(handleConsignmentAddNotes(newNotes));
    } else if (isFromReportUsage) {
        const newNotes = [
            {
                reportUsageNotes: [...notesOneDisplay],
                reportReplenishmentNotes: updatedNotesTwoDisplay,
            },
        ];
        dispatch(handleReportUsageNotes(newNotes));
    }
    
    setEditNoteTwo(null);
    setEditNoteTwoValue(null);
};